import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export function useRouteConfig() {
  const route = useRoute()
  const store = useStore()

  const isAuthenticated = computed(() => !!store.state.user.user)

  const shouldShowSideNav = computed(() => {
    if (!isAuthenticated.value) return false
    return !route.meta.hideSidebar
  })

  const shouldShowHeader = computed(() => {
    return !route.meta.hideHeader
  })

  return {
    isAuthenticated,
    shouldShowSideNav,
    shouldShowHeader
  }
}